import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { CommonMaterialComponentsModule } from '@quorum/common-material-components';
import { CommonPipesModule } from '@quorum/common-pipes';
import { NgPipesModule } from 'ngx-pipes';
import { DeclinedServicesComponent } from './declined-services/declined-services.component';
import { ServiceHistoryComponent } from './service-history/service-history.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    CommonMaterialComponentsModule,
    CommonPipesModule,
    FlexLayoutModule,
    NgPipesModule,
    ReactiveFormsModule,
  ],
  declarations: [ServiceHistoryComponent, DeclinedServicesComponent],
  exports: [ServiceHistoryComponent, DeclinedServicesComponent],
})
export class ShaWorkOrdersNgUiModule {}
